// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopBankCardControllerActivateBankCardData } from './EshopBankCardControllerActivateBankCardData.gen';
import type { EshopBankCardControllerActivateBankCardErrors } from './EshopBankCardControllerActivateBankCardErrors.gen';
import type { EshopBankCardControllerActivateBankCardResponses } from './EshopBankCardControllerActivateBankCardResponses.gen';
import type { EshopBankCardControllerBlockBankCardData } from './EshopBankCardControllerBlockBankCardData.gen';
import type { EshopBankCardControllerBlockBankCardErrors } from './EshopBankCardControllerBlockBankCardErrors.gen';
import type { EshopBankCardControllerBlockBankCardResponses } from './EshopBankCardControllerBlockBankCardResponses.gen';
import type { EshopBankCardControllerFinishTokenizationData } from './EshopBankCardControllerFinishTokenizationData.gen';
import type { EshopBankCardControllerFinishTokenizationErrors } from './EshopBankCardControllerFinishTokenizationErrors.gen';
import type { EshopBankCardControllerFinishTokenizationResponses } from './EshopBankCardControllerFinishTokenizationResponses.gen';
import type { EshopBankCardControllerGetCustomerBankCardsData } from './EshopBankCardControllerGetCustomerBankCardsData.gen';
import type { EshopBankCardControllerGetCustomerBankCardsErrors } from './EshopBankCardControllerGetCustomerBankCardsErrors.gen';
import type { EshopBankCardControllerGetCustomerBankCardsResponses } from './EshopBankCardControllerGetCustomerBankCardsResponses.gen';
import type { EshopBankCardControllerInitTokenizationData } from './EshopBankCardControllerInitTokenizationData.gen';
import type { EshopBankCardControllerInitTokenizationErrors } from './EshopBankCardControllerInitTokenizationErrors.gen';
import type { EshopBankCardControllerInitTokenizationResponses } from './EshopBankCardControllerInitTokenizationResponses.gen';
import type { EshopBankCardControllerRemoveBankCardData } from './EshopBankCardControllerRemoveBankCardData.gen';
import type { EshopBankCardControllerRemoveBankCardErrors } from './EshopBankCardControllerRemoveBankCardErrors.gen';
import type { EshopBankCardControllerRemoveBankCardResponses } from './EshopBankCardControllerRemoveBankCardResponses.gen';
import type { Options } from './Options.gen';

export class EshopBankCardController {
    /**
     * Get bank card info list for the given customer.
     */
    public static getCustomerBankCards<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerGetCustomerBankCardsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopBankCardControllerGetCustomerBankCardsResponses, EshopBankCardControllerGetCustomerBankCardsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/{customerId}',
            ...options
        });
    }
    
    /**
     * Init a tokenization.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CUSTOMER_ACCOUNT_NOT_VERIFIED** - Customer account is not verified.<br>
     * + **CANNOT_INIT_TOKENIZATION** - Tokenization cannot be initialized.
     */
    public static initTokenization<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerInitTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopBankCardControllerInitTokenizationResponses, EshopBankCardControllerInitTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/init-tokenization/{cardApplicationId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Finish a tokenization.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CARD_APPLICATION** - Card application is invalid or does not exist.<br>
     * + **CHIP_NUMBER_NOT_UNIQUE** - Chip number already exists.<br>
     * + **CARD_HAS_UNPROCESSED_TRANSACTIONS** - Card has unprocessed transactions. Upload all transactions to card first.<br>
     * + **CANNOT_FINISH_TOKENIZATION** - Tokenization cannot be finished.
     */
    public static finishTokenization<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerFinishTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopBankCardControllerFinishTokenizationResponses, EshopBankCardControllerFinishTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/finish-tokenization',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Block active bank card.
     */
    public static blockBankCard<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerBlockBankCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopBankCardControllerBlockBankCardResponses, EshopBankCardControllerBlockBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/{id}/block',
            ...options
        });
    }
    
    /**
     * Activate blocked bank card.
     */
    public static activateBankCard<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerActivateBankCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopBankCardControllerActivateBankCardResponses, EshopBankCardControllerActivateBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/{id}/activate',
            ...options
        });
    }
    
    /**
     * Remove tokenized or blocked bank card.
     */
    public static removeBankCard<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerRemoveBankCardData, ThrowOnError>) {
        return (options.client ?? client).delete<EshopBankCardControllerRemoveBankCardResponses, EshopBankCardControllerRemoveBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/{id}',
            ...options
        });
    }
}
